module.exports = __webpack_public_path__ + "static/media/lanes-fine-jewelry.c9f01922.jpg";